import { SignInState } from './SignInState';

export interface IPlatformState {
    isInstallFromUpdate: boolean;
    IAPSupport: boolean;
    IAPIsReady: boolean;
    adsInterstitial: boolean;
    adsRewarded: boolean;
    switchGame: boolean;
    subscribeBot: boolean;
    crossPromoSupport: boolean;
    signInState: SignInState;
}

export const initialPlatformState: IPlatformState = {
    IAPSupport: false,
    IAPIsReady: false,
    adsInterstitial: false,
    adsRewarded: false,
    switchGame: false,
    subscribeBot: false,
    crossPromoSupport: false,
    isInstallFromUpdate: false,
    signInState: SignInState.SignedOut,
};
